<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from "vue";
import { useApiClient } from "@/api/client";
import { useExplorerStore } from "@/modules/explorer/store";
import { DataStreamStatus } from "@/modules/explorer/explorerTypes";
import dayjs from "dayjs";

const dataStreams = ref<DataStreamStatus[]>([]);
const loading = ref(true);

const getDataStatus = async () => {
	const response = await useApiClient("explorer").getDataStreamStatus(
		useExplorerStore().document.uuid
	);
	loading.value = false;

	if (response.isOk()) {
		dataStreams.value = response.value;
	}
};

const formatDate = (date: number | string) => {
	if (typeof date === "string") {
		return dayjs(date).format("DD MMM YYYY HH:mm");
	}
	return dayjs.unix(date).format("DD MMM YYYY HH:mm");
};

onMounted(() => {
	getDataStatus();
});

onBeforeUnmount(() => {
	loading.value = true;
});
</script>

<template>
	<v-card class="pa-4" min-height="200px">
		<div class="text-h6 mb-2" style="color: rgb(var(--color-on-surface))">
			Data Stream Status
		</div>

		<v-progress-circular
			v-if="loading"
			indeterminate
			color="primary"
			class="my-4 mx-auto"
		/>

		<div class="d-flex flex-column ga-4">
			<v-card
				class="pa-2 w-100"
				v-for="dataStream in dataStreams"
				:key="dataStream.store_table_name"
			>
				<table>
					<tbody>
						<tr>
							<td style="font-weight: 500; font-size: 1.1rem">
								{{ dataStream.store_table_name }}
							</td>
							<td
								style="font-weight: 500; font-size: 0.9rem"
								class="text-right"
							>
								{{ formatDate(dataStream.cycle_timestamp_preparation) }}
							</td>
						</tr>
						<tr
							v-for="underlying in dataStream.underlying_internals"
							:key="underlying.identifier"
							style="font-weight: 400; font-size: 0.9rem"
						>
							<td>
								{{ underlying.identifier }}
							</td>
							<td class="text-right">
								{{ formatDate(underlying.timestamp) }}
							</td>
						</tr>
					</tbody>
				</table>
			</v-card>
		</div>
	</v-card>
</template>

<style scoped lang="scss">
table {
	border-collapse: collapse;
}
td {
	padding: 3px 6px;
	min-width: 200px;
}
tr:nth-child(even) {
	background-color: rgb(var(--color-background));
}
</style>
